import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String,
    position: { type: String, default: "bottom" }
  }

  connect() {
    this.tooltip = null
    this.element.addEventListener("mouseenter", this.show.bind(this))
    this.element.addEventListener("mouseleave", this.hide.bind(this))
    this.element.addEventListener("focus", this.show.bind(this))
    this.element.addEventListener("blur", this.hide.bind(this))
  }

  disconnect() {
    this.hide()
  }

  show() {
    if (this.tooltip) return

    this.tooltip = document.createElement("div")
    this.tooltip.className = "fixed px-3 py-1.5 text-xs font-medium text-white bg-stone-900 rounded-md shadow-md pointer-events-none transition-opacity duration-150"
    this.tooltip.style.zIndex = "9999"
    this.tooltip.textContent = this.textValue
    this.tooltip.style.opacity = "0"
    document.body.appendChild(this.tooltip)

    // Position the tooltip
    requestAnimationFrame(() => {
      this.positionTooltip()
      this.tooltip.style.opacity = "1"
    })
  }

  hide() {
    if (this.tooltip) {
      this.tooltip.remove()
      this.tooltip = null
    }
  }

  positionTooltip() {
    if (!this.tooltip) return

    const rect = this.element.getBoundingClientRect()
    const tooltipRect = this.tooltip.getBoundingClientRect()
    const gap = 8

    let top, left

    switch (this.positionValue) {
      case "top":
        top = rect.top - tooltipRect.height - gap
        left = rect.left + (rect.width - tooltipRect.width) / 2
        break
      case "bottom":
      default:
        top = rect.bottom + gap
        left = rect.left + (rect.width - tooltipRect.width) / 2
        break
      case "left":
        top = rect.top + (rect.height - tooltipRect.height) / 2
        left = rect.left - tooltipRect.width - gap
        break
      case "right":
        top = rect.top + (rect.height - tooltipRect.height) / 2
        left = rect.right + gap
        break
    }

    // Keep tooltip within viewport
    const padding = 8
    left = Math.max(padding, Math.min(left, window.innerWidth - tooltipRect.width - padding))
    top = Math.max(padding, Math.min(top, window.innerHeight - tooltipRect.height - padding))

    this.tooltip.style.top = `${top}px`
    this.tooltip.style.left = `${left}px`
  }
}
